const emojiMap = {
    "[微笑]": "😊",
    "[大哭]": "😭",
    "[憨笑]": "😄",
    "[呲牙]": "😁",
    "[撇嘴]": "😒",
    "[调皮]": "😜",
    "[难过]": "😞",
    "[闭嘴]": "🤐",
    "[流汗]": "😅",
    "[害羞]": "☺️",
    "[睡觉]": "😴",
    "[愤怒]": "😠",
    "[尴尬]": "😬",
    "[惊讶]": "😲",
    "[酷]": "😎",
    "[奋斗]": "💪",
    "[疑问]": "❓",
    "[嘘]": "🤫",
    "[口罩]": "😷",
    "[开心]": "😄",
    "[色]": "😍",
    "[忧郁]": "😔",
    "[呆]": "😳",
    "[飞吻]": "😘",
    "[媚眼]": "😉",
    "[气愤]": "😤",
    "[囧]": "😅",
    "[累]": "😩",
    "[鄙视]": "😒",
    "[高兴]": "😃",
    "[亲亲]": "😗",
    "[擦汗]": "😓",
    "[哭笑]": "😂",
    "[可爱]": "🥰",
    "[鬼脸]": "😜",
    "[我晕]": "😵",
    "[紧张]": "😰",
    "[抓狂]": "🤯",
    "[奸笑]": "😏",
    "[害怕]": "😨",
    "[冷汗]": "😰",
    "[困惑]": "😕",
    "[笑]": "😆",
    "[亲一下]": "😚",

    "[外星人]": "👽",
    "[恶魔]": "😈",
    "[鬼]": "👻",
    "[圣诞老人]": "🎅",
    "[小狗]": "🐶",
    "[猪]": "🐷",
    "[猫]": "🐱",

    "[手机]": "📱",
    "[楼房]": "🏢",
    "[车]": "🚗",
    "[礼物]": "🎁",
    "[足球]": "⚽",
    "[炸弹]": "💣",
    "[钻石]": "💎",
    "[放大镜]": "🔍",
    "[玫瑰花]": "🌹",
    "[咖啡]": "☕",
    "[蛋糕]": "🍰",
    "[钟]": "⏰",
    "[啤酒]": "🍺",
    "[游戏柄]": "🎮",
    "[美元]": "💵",

    "[太阳]": "☀️",
    "[月亮]": "🌙",
    "[星星]": "⭐",
    "[闪电]": "⚡",
    "[云]": "☁️",
    "[雨伞]": "☔",
    "[西瓜]": "🍉",
    "[绿豆汤]": "🥣",

    "[拳头]": "👊",
    "[握拳]": "✊",
    "[手势]": "🤟",
    "[强壮]": "💪",
    "[鼓掌]": "👏",
    "[左边]": "⬅️",
    "[上边]": "⬆️",
    "[右边]": "➡️",
    "[下边]": "⬇️",
    "[好的]": "👌",

    "[你不行]": "🙅‍♂️",
    "[爱心]": "❤️",
    "[心碎]": "💔",
    "[厉害]": "💥",
    "[求救]": "🆘",
    "[困了]": "🥱",
    "[满分]": "🌟",
    "[火箭]": "🚀",
    "[阿弥陀佛]": "🙏",
    "[看书]": "📖",
    "[麦霸]": "🎤"
};
export const replaceWeChatEmojiTags = (text) => {
    return text.replace(/\[\s*[,，]?\s*([^\]\s]+)\s*\]/g, (match, tag) => {
        const key = `[${tag}]`;
        return emojiMap[key] || match;
    });
};